import asModal from "lib/modal/asModal";
import React from "react";
import PrintDialog from "lib/dataentry/lib/print/PrintDialog";

const PrintModule = asModal("Print Options")(props => {
    const {
        triggerClose,
        ...passthrough
    } = props;

    const handleCancel = () => {
        triggerClose();
    };

    return <PrintDialog
        {...passthrough}
        onCancel={handleCancel}
    />;
});

export default PrintModule;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/print/PrintModule.js